// USER TYPES
export const FETCHING = 'FETCHING';
export const UPLOAD = 'UPLOAD';
export const CREATE = 'CREATE';
export const FETCH_FAIL = 'FETCH_FAIL';
